import { useGetLeadByTokenQuery } from '../api/apiSlice'
import { Alert, CircularProgress, Typography } from '@mui/material'
import { FormDefinition } from '../api/interfaces'
import { StepperLayout } from './StepperLayout'
import { MemoryRouter, Route, Routes } from 'react-router-dom'
import { FormStepRenderer } from './FormStepRenderer'
import { useAppDispatch } from '../../app/hooks'
import { setToken } from './formSlice'
import React from 'react'
import { Success } from './steps/Success'
import { useTranslation } from 'react-i18next'

interface FormProps {
    token: string
    form: FormDefinition
}

export const Form = ({ token, form }: FormProps) => {
    const { t } = useTranslation()
    const { data: lead, error: leadError } = useGetLeadByTokenQuery(token)
    const dispatch = useAppDispatch()

    React.useEffect(() => {
        if (lead) {
            dispatch(setToken(token))
        }
    }, [lead])

    const agreementsDefinition = {
        component: 'Agreements'
    }

    if (lead && lead.submitted) {
        return <>
            <Typography mb={4} variant="h5" component="h1">{t('Processing.heading')}</Typography>
            <Typography mb={2} variant="body1">{t('Processing.text1')}</Typography>
            <Typography mb={2} variant="body1">{t('Processing.text2')}</Typography>
        </>
    }

    if (leadError) {
        return <Alert severity="error">{t('formError')}</Alert>
    }

    if (lead) {
        return <MemoryRouter initialEntries={['/' + lead.currentStep]}>
            <Routes>
                <Route path="/" element={<StepperLayout lead={lead} form={form}/>}>
                    {form.steps.map((item, index) =>
                        <Route
                            key={index}
                            index={lead.currentStep === item.component}
                            element={<FormStepRenderer form={form} formStepDefinition={item}/>}
                            path={item.component}
                        />
                    )}
                    <Route
                        key="Agreements"
                        index={lead.currentStep === 'Agreements'}
                        element={<FormStepRenderer form={form} formStepDefinition={agreementsDefinition}/>}
                        path={agreementsDefinition.component}
                    />
                    <Route
                        key="Success"
                        element={<Success/>}
                        path={'Success'}
                    />
                </Route>
            </Routes>
        </MemoryRouter>
    }

    return <CircularProgress/>
}
